import React from 'react';
import TextField from '../TextField/TextField';

const isSpaceKey = event => event.key === ' ' || event.code === 'Space';

const Search = ({ SearchInputProps = {}, className }) => {
  const { onKeyDown, ...RestOfSearchInputProps } = SearchInputProps;
  return (
    <TextField
      data-qa-id="search-input"
      fullWidth
      autoFocus // eslint-disable-line jsx-a11y/no-autofocus
      variant="outlined"
      className={className}
      {...RestOfSearchInputProps}
      onKeyDown={event => {
        if (isSpaceKey(event)) {
          // prevent react-select from selecting an option
          event.stopPropagation();
        } else if (onKeyDown) {
          onKeyDown(event);
        }
      }}
    />
  );
};

export default Search;
